<template>
  <main-layout>
    <b-paginated-table :items="items" :fields="fields" sort-by="contenu">
      <template v-slot:top-row>
        <td colspan="100%">
          <b-button block variant="outline-primary" @click="Voir('new')">
            <b-icon-plus class="mr-2"/>
            <span>Nouveau</span>
          </b-button>
        </td>
      </template>
      <template #cell(prix)="{value}">
        {{ value }} €
      </template>
      <template #cell(adresse_paypal)="{value}">
        <a :href="value">{{ value }}</a>
      </template>
      <template #cell(Action)="{item}">
        <div>
          <b-btn variant="primary" @click="Voir(item.id)">Voir</b-btn>
        </div>
      </template>
    </b-paginated-table>
  </main-layout>
</template>

<script>
import BPaginatedTable from "@/components/BPaginatedTable";
import {Produit} from "@/js/caller";

export default {
  name      : "ProduitListVue",
  components: {BPaginatedTable},
  data() {
    return {
      fields: [{ key: 'contenu', sortable: true, filterable:true }, "prix", "adresse_paypal", "Action"],
      items : []
    }
  },
  methods: {
    Voir(id) {
      this.$router.push({name: "ProduitEditorVue", params: {id}})
    },
  },
  created() {
    Produit.List().then(res => {
      this.items = res
    })
  }
}
</script>

<style scoped>

</style>